import { orderUploadPageContainerStyles } from "@insite/content-library/Widgets/OrderUpload/OrderUploadPageContainer";
import { css } from "styled-components";

orderUploadPageContainerStyles.container = {
    css: css`
        padding: 0rem 9px;
        margin: 0 auto;
        width: 100%;
        > div[class^="GridOffset"]:last-child {
            > div[class^="GridItemStyle"] {
                > div[class^="Wrapper"] {
                    > div[class^="ContentWrapper"] {
                        border-radius: 8px;
                    }
                }
            }
        }
    `,
};
